<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Registrar Evento Masivo</v-toolbar>
        <v-card-text>
          <v-container class="mt-1">
            <v-select
              label="* Sucursal"
              v-model="evento.codigoSucursal"
              :items="sucursales"
              item-value="numero_sucursal"
              :loading="loadingsuc"
              dense
              outlined
              :readonly="frompuntoventa"
              color="green"
            ></v-select>
            <v-select
              label="* Punto de venta"
              v-model="evento.codigoPuntoVenta"
              :items="puntos"
              item-value="codigo_punto_venta"
              :loading="loadingpuntos"
              dense
              :readonly="frompuntoventa"
              color="green"
              outlined
            ></v-select>
            <v-text-field label="* Descripcion" v-model.trim="evento.descripcion" dense outlined></v-text-field>
          </v-container>

          <v-progress-linear indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="save()" class="green darken-2" dark :disabled="loading">
            {{ evento.id ? 'Actualizar' : 'Registrar' }}
          </v-btn>
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        loadingsuc: false,
        loadingmot: false,
        loadingpuntos: false,
        msg: '',
        puntos: [],
        sucursales: [],
        frompuntoventa: false,
        evento: {
          id: null,
          codigo: 'string',
          codigoPuntoVenta: null,
          codigoSucursal: null,
          descripcion: 'string',
        },
      };
    },
    components: {},
    watch: {
      'evento.codigoSucursal': function() {
        //window.console.log(this.evento.codigoSucursal);
        if (this.evento.codigoSucursal != null) {
          this.getpuntosv(this.evento.codigoSucursal);
        }
      },
    },
    methods: {
      openmodal(item, puntoventa = null) {
        window.console.log(puntoventa);
        this.msg = '';
        this.dialog = true;
        this.frompuntoventa = false;
        this.getsucursales();
        //this.getpuntosv();
        this.evento.id = null;
        this.evento.codigo = '';
        this.evento.codigoPuntoVenta = null;
        this.evento.codigoSucursal = null;
        this.evento.descripcion = '';
        if (puntoventa) {
          this.evento.codigoSucursal = puntoventa.codigoSucursal;
          this.evento.codigoPuntoVenta = puntoventa.codigoPuntoVenta;
          this.frompuntoventa = true;
          let idsucursal = this.$route.query.idsucursal;
          this.getpuntosv(idsucursal);
        }
        if (item) {
          this.evento.id = item.id;
          this.evento.codigo = item.codigo;
          this.evento.codigoPuntoVenta = item.codigoPuntoVenta;
          this.evento.codigoSucursal = item.codigoSucursal;
          this.evento.descripcion = item.descripcion;
        }
      },
      getsucursales() {
        let vue = this;
        this.loadingsuc = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            data.map((x) => {
              x.text = `[${x.numero_sucursal}] (${x.ciudad}) ${x.direccion}`;
            });
            vue.sucursales = response.data.data;
            vue.loadingsuc = false;
            window.console.log('getsucursales:', vue.sucursales);
          })
          .catch(function(error) {
            vue.loadingsuc = false;
            window.console.log(error);
          });
      },
      getpuntosv(idsucursal) {
        this.puntos = [];
        let vue = this;
        vue.loadingpuntos = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/puntosventas?sucursalId=${idsucursal}`,
          headers: {
            //apikey: '4265269017',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log('puntos:', data);
            data.map((x) => {
              x.text = `[${x.codigo_punto_venta}] (${x.id}).- ${x.nombre} ${x.descripcion}`;
            });
            vue.puntos = data;
            vue.loadingpuntos = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingpuntos = false;
          });
      },
      save() {
        this.msg = '';
        //if (!this.evento.codigo) this.msg = 'Seleccione el motivo.';
        //if (!this.evento.codigoPuntoVenta) this.msg = 'Seleccione un punto de venta.';
        //if (!this.evento.codigoSucursal) this.msg = 'Seleccione una sucursal.';
        if (!this.evento.descripcion) this.msg = 'Ingrese la descripcion.';
        if (this.msg) return;

        this.loading = true;
        let metodo = 'post';
        if (this.evento.id) metodo = 'put';
        const vue = this;
        var config = {
          method: metodo,
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/eventomasivo`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
          data: this.evento,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            if (data.id) {
              vue.msg = `Registrado, ID:${data.id}`;
              vue.$emit('newregevento', data);
            }
            window.console.log('eventonew::', data);
            vue.loading = false;
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch(function(error) {
            window.console.log(error.response.data);
            let data = error.response.data;
            vue.msg = `${data.mensaje}`;
            vue.loading = false;
          });
      },
    },
  };
</script>
